import { render, staticRenderFns } from "./TwCard.vue?vue&type=template&id=50806398&scoped=true"
import script from "./TwCard.vue?vue&type=script&lang=js"
export * from "./TwCard.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./TwCard.vue?vue&type=style&index=0&id=50806398&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "50806398",
  null
  ,true
)

export default component.exports